import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Grid,
} from '@mui/material';
import Budget from 'src/components/dashboard//Budget';
import LatestOrders from 'src/components/dashboard//LatestOrders';
import LatestProducts from 'src/components/dashboard//LatestProducts';
import TasksProgress from 'src/components/dashboard//TasksProgress';
import TotalCustomers from 'src/components/dashboard//TotalCustomers';
import TotalProfit from 'src/components/dashboard//TotalProfit';
import TrafficByDevice from 'src/components/dashboard//TrafficByDevice';
import { DashboardContext } from 'src/context/DashboardContex';
import { useContext, useEffect } from 'react';
import OrdersExpired from 'src/components/dashboard/OrdersExpired';
import TitleComponent from 'src/components/TitleComponent';

const Dashboard = () => {
  const {
    status,
    getStatus,
    statusPie,
    getStatusPie,
    getLastOrders,
    lastOrders,
    getLastProducts,
    lastProducts,
    expiredOrders,
    getExpiredOrders,
    setLoading
  } = useContext(DashboardContext);

  useEffect(async () => {
    setLoading(true);
    Promise.all([
      getStatusPie(),
      getStatus(),
      getLastOrders(),
      getLastProducts(),
      getExpiredOrders()
    ]).then(setLoading(false));
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {`Dashboard | ${process.env.REACT_APP_NAME}`}
        </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <TitleComponent title="Dashboard" />
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              lg={3}
              sm={6}
              xl={3}
              xs={12}
            >
              <Budget value={status} />
            </Grid>
            <Grid
              item
              lg={3}
              sm={6}
              xl={3}
              xs={12}
            >
              <TotalCustomers value={status} />
            </Grid>
            <Grid
              item
              lg={3}
              sm={6}
              xl={3}
              xs={12}
            >
              <TasksProgress value={status} />
            </Grid>
            <Grid
              item
              lg={3}
              sm={6}
              xl={3}
              xs={12}
            >
              <TotalProfit sx={{ height: '100%' }} value={status} />
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
            >
              <OrdersExpired orders={expiredOrders} />
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              xl={6}
              xs={6}
            >
              <TrafficByDevice status={statusPie} sx={{ height: '100%' }} />
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              xl={6}
              xs={12}
            >
              <LatestProducts products={lastProducts} sx={{ height: '100%' }} />
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
            >
              <LatestOrders orders={lastOrders} />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Dashboard;
